unit PrjFormPDFViewer;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  VCL.TMSFNCTypes,
  VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics,
  VCL.TMSFNCGraphicsTypes,
  Vcl.Controls,
  VCL.TMSFNCCustomControl,
  VCL.TMSFNCWebBrowser,
  VCL.TMSFNCCustomWEBControl,
  VCL.TMSFNCWXPDFViewer,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Buttons,
  Vcl.Imaging.pngimage,
  WEBLib.ExtCtrls, VCL.TMSFNCCustomScrollControl, VCL.TMSFNCCustomList, VCL.TMSFNCWXPDFThumbnailList, Vcl.Imaging.jpeg;

type
  TPrjFormsPDFViewer = class(TWebForm)
    TMSFNCWXPDFViewer1: TTMSFNCWXPDFViewer;
    WebOpenDialog1: TWebOpenDialog;
    WebToolBar1: TWebToolBar;
    BtLoadPDF: TWebImageControl;
    BtPreviousPage: TWebImageControl;
    BtNextPage: TWebImageControl;
    BtZoomIn: TWebImageControl;
    BtZoomOut: TWebImageControl;
    BtRotateLeft: TWebImageControl;
    BtRotateRight: TWebImageControl;
    TMSFNCWXPDFThumbnailList1: TTMSFNCWXPDFThumbnailList;
    WebImageControl1: TWebImageControl;
    procedure BtLoadPDFClick(Sender: TObject);
    procedure BtPreviousPageClick(Sender: TObject);
    procedure BtNextPageClick(Sender: TObject);
    procedure BtZoomInClick(Sender: TObject);
    procedure BtZoomOutClick(Sender: TObject);
    procedure BtRotateLeftClick(Sender: TObject);
    procedure BtRotateRightClick(Sender: TObject);
    procedure TMSFNCWXPDFViewer1ViewerInitialized(Sender: TObject);
    procedure WebImageControl1Click(Sender: TObject);
  private
    FURL: string;
    { Private declarations }
    [async]
    procedure LoadFile;
  public
    { Public declarations }
  published
    property URL: string read FURL write FURL;
  end;

var
  PrjFormsPDFViewer: TPrjFormsPDFViewer;

implementation


{$R *.dfm}

procedure TPrjFormsPDFViewer.BtRotateRightClick(Sender: TObject);
begin
  TMSFNCWXPDFViewer1.TurnAngleRight;
end;

procedure TPrjFormsPDFViewer.BtRotateLeftClick(Sender: TObject);
begin
  TMSFNCWXPDFViewer1.TurnAngleLeft;
end;

procedure TPrjFormsPDFViewer.BtZoomOutClick(Sender: TObject);
begin
  TMSFNCWXPDFViewer1.ZoomOut;
end;

procedure TPrjFormsPDFViewer.BtZoomInClick(Sender: TObject);
begin
  TMSFNCWXPDFViewer1.ZoomIn;
end;

procedure TPrjFormsPDFViewer.BtNextPageClick(Sender: TObject);
begin
  TMSFNCWXPDFViewer1.NextPage;
end;

procedure TPrjFormsPDFViewer.BtPreviousPageClick(Sender: TObject);
begin
  TMSFNCWXPDFViewer1.PreviousPage;
end;

procedure TPrjFormsPDFViewer.BtLoadPDFClick(Sender: TObject);
begin
  LoadFile;
end;

procedure TPrjFormsPDFViewer.LoadFile;
var LdoLoad   : boolean;
var LpdfData  : string;
begin
//  LdoLoad := await(Boolean, WebOpenDialog1.Perform);
//  if LdoLoad then
//  begin
//    LpdfData := await(string, WebOpenDialog1.Files[0].FileAsBase64);
//    TMSFNCWXPDFViewer1.LoadFromBase64(LpdfData);
//  end;
end;

procedure TPrjFormsPDFViewer.TMSFNCWXPDFViewer1ViewerInitialized(Sender: TObject);
begin
  TMSFNCWXPDFViewer1.LoadFromUrl(FURL) ;
  console.log(FURL);
end;

procedure TPrjFormsPDFViewer.WebImageControl1Click(Sender: TObject);
begin
  close;
end;

end.
